import { render } from "./TaxTitleAndDate.vue?vue&type=template&id=5055bad4&scoped=true"
import script from "./TaxTitleAndDate.vue?vue&type=script&lang=js"
export * from "./TaxTitleAndDate.vue?vue&type=script&lang=js"

import "./TaxTitleAndDate.vue?vue&type=style&index=0&id=5055bad4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5055bad4"]])

export default __exports__